import { render, staticRenderFns } from "./NavigationLeftMenuCollapsed.vue?vue&type=template&id=02138871&scoped=true"
import script from "./NavigationLeftMenuCollapsed.vue?vue&type=script&lang=js"
export * from "./NavigationLeftMenuCollapsed.vue?vue&type=script&lang=js"
import style0 from "./NavigationLeftMenuCollapsed.vue?vue&type=style&index=0&id=02138871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02138871",
  null
  
)

export default component.exports